export const overallRecommendation = {
    STRONGLY_PROCEED: "STRONG_PROCEED",
    PROCEED: "PROCEED",
    REJECT: "REJECT",
    STRONGLY_REJECT: "STRONG_REJECT",
  };